/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.userBusinessDrawsParticipations.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Business draw participations.
 */
@ExperimentalJsExport
@JsExport
@Serializable
data class ParticipationsModel(
    @SerialName("data")
    val data: List<ParticipationModel>?
) : Model()
